const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
})

export default styles
